import React from 'react';
import '../../assets/less/index.less'
import 'react-datepicker/dist/react-datepicker.css';


export default class App extends React.Component {
    render() {
        return (
            <div id="app-view">
                {this.props.children}
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./app/containers/layouts/App.jsx